import { Controller } from '@hotwired/stimulus';
import { enter, leave } from 'el-transition';

// Connects to data-controller="country-selector"
export default class extends Controller {
  static targets = ['countrySelect', 'countryCodeDisplay']

  connect() {
    setTimeout(() => {
      this.countrySelectTarget.value = 'US'
      this.countrySelectTarget.dispatchEvent(new Event('change'));
    }, 300)
  }

  changeCountry(e) {
    e.preventDefault()
    const selectedOption = e.target.options[e.target.selectedIndex]
    const display = selectedOption.dataset.display
    this.countryCodeDisplayTarget.textContent = display
  }
}
